import styled from 'styled-components';
import {
  variant,
  themeGet,
  borders,
  BordersProps,
  justifyContent,
  JustifyContentProps,
  buttonStyle
} from 'styled-system';
import { basicTheme, candidateTheme, employerTheme } from 'src/theme';
import { positionStyles } from './Box';
import { textBoxStyles, TextBoxProps } from './Text';

export const buttonSize = variant({
  key: 'buttonSizes',
  prop: 'size'
});

export const BaseButton = styled.button.attrs(props => ({
  type: props.type || 'button'
}))<{ as?: any }>`
  padding: 0;
  pointer-events: auto;
  appearance: none;
  background-color: transparent;
  border: none;
  cursor: ${props => !props.as && 'pointer'};
  font-family: ${themeGet('fonts.base')};
  font-size: inherit;
  font-weight: inherit;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  outline: none;

  &:disabled {
    cursor: not-allowed;
  }

  &:hover {
    text-decoration: none;
  }
`;

export type StyledButtonProps = TextBoxProps &
  JustifyContentProps &
  BordersProps & {
    variant?:
      | keyof typeof basicTheme.buttons
      | keyof typeof candidateTheme.buttons
      | keyof typeof employerTheme.buttons;
    size?: keyof typeof basicTheme.buttonSizes;
  };

export const StyledButton = styled(BaseButton)<StyledButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  color: inherit;
  font-weight: normal;
  user-select: none;
  border-radius: 4px;
  line-height: 1;

  ${buttonStyle};
  ${buttonSize};
  ${positionStyles};
  ${textBoxStyles};
  ${borders};
  ${justifyContent};
`;

export const Button = StyledButton;
